import { CUSTOMER_FRAGMENT } from '@/quote-management/api/graphql/CustomerFragment';

export const CUSTOMER_QUERY = `
    query CUSTOMER_QUERY {
        customer {
            ...CUSTOMER_FRAGMENT
        }
    }

    ${CUSTOMER_FRAGMENT}
`